import {isDefined, isTrue} from "../../libs/utils/epic.utils";
import {ChartOfAccount} from "../../libs/enum/chart-of-account.enum";

export class BookingCategoryDto {

  public id!: string;
  public name!: string;
  public skr03: number | undefined;
  public skr04: number | undefined;
  public readonly chartOfAccounts!: ChartOfAccount;
  public system!: boolean;

  constructor(init?: Partial<BookingCategoryDto> | undefined) {
    Object.assign(this, init);
  }

  public isEditable(): boolean {
    return true;
  }

  public isSystem(): boolean {
    return isTrue(this.system);
  }

  public isCustom(): boolean {
    return !this.isSystem();
  }

  public getNumber(): number | undefined {
    switch (this.chartOfAccounts) {
      case ChartOfAccount.SKR03:
        return this.skr03;
      case ChartOfAccount.SKR04:
        return this.skr04;
      default:
        return undefined;
    }
  }

  public getFormattedNumber(): string | undefined {
    const number = this.getNumber();
    return isDefined(number) ? number.toString().padStart(4, '0') : undefined;
  }
}
